<template>
  <div :class="['layer-legend', 'item-padding', legendClass]">
    <div class="layer-legend__title-bar">
      <h2 class="layer-legend__title">
        {{ layerName }}
      </h2>
      <tooltip
        :class="['tooltip--left', 'flex-hs-end', tooltipClass]"
        :text="layerDescription"
      >
        <div class="tooltip-icon" />
      </tooltip>
    </div>
    <div
      v-if="categorical"
      class="layer-legend__body"
    >
      <ul class="layer-legend__items">
        <li
          v-for="category in layer.layer_pixel_value_joins"
          :key="category.id"
          :class="getItemClass(category)"
        >
          <div class="layer-legend__category">
            <span
              class="layer-legend__colour"
              :style="{'background-color': category.color}"
            />
            {{ category.name }}
          </div>
        </li>
      </ul>
    </div>
    <div
      v-else
      class="layer-legend__body"
    >
      <div
        class="layer-legend__gradient"
        :style="legendGradient"
      />
      <div class="flex flex-h-between">
        <span>Low</span>
        <span>High</span>
      </div>
    </div>
  </div>
</template>

<script>
import './layer-legend.scss'
import Tooltip from '../../tooltip/Tooltip'

export default {
  components: {Tooltip},
  props: {
    layer: {
      type: Object,
      default: () => {}
    },
    categorical: {
      type: Boolean
    }
  },

  computed: {
    layerName () {
      return this.layer ? this.layer.name : ''
    },

    layerDescription () {
      return this.layer ? this.layer.description : ''
    },

    legendClass () {
      return this.layer ?
        this.categorical ? 'layer-legend--categorical' : 'layer-legend--continuous' :
        'hidden'
    },

    tooltipClass () {
      return !this.categorical ? 'tooltip--above' : ''
    },

    legendGradient() {
      if (!this.layer) { return '' }

      if (this.layer.map_type === 'Raster') {
        let colours = JSON.parse(this.layer.colour_ramp).join(', ')

        return {
          background: `linear-gradient(to right, ${colours})`
        }
      } else {
        let colours = this.cartoColours.join(', ')

        return {
          background: `linear-gradient(to right, ${colours})`
        }
      }
    }
  },

  methods: {
    getItemClass (category) {
      return ['layer-legend__item', { 'layer-legend__item--heading': category.heading }]
    }
  }
}
</script>
